export default "__VITE_ASSET__DfMPVqc3__"